export default __webpack_public_path__ + "static/media/arrow-down-gray.65ef1cc9.svg";